module.exports = __webpack_public_path__ + "static/media/noPosterSmall.334a3daf.png";